// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"543":"gallery","962":"home"}[chunkId] + "." + {"543":"e9fa90a1","962":"17d3afd6"}[chunkId] + ".js";
};